import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {PipelineStepDataFragment} from 'pipelines/graphql/PipelineStepDataFragment';
import {PipelineStepFragment} from 'pipelines/graphql/PipelineStepFragment';

import {PipelineViewFragment as PipelineViewFragmentType} from './__generated/PipelineViewFragment';

export const PIPELINE_VIEW_FRAGMENT = gql`
  fragment PipelineViewFragment on PipelineViewNode {
    lineage {
      step {
        ...PipelineStepFragment
      }
      stepOutputReference {
        outputStepData {
          ...PipelineStepDataFragment
        }
        rawDataIndex
      }
    }
  }

  ${PipelineStepFragment.fragment}
  ${PipelineStepDataFragment.fragment}
`;

export const PipelineViewFragment: FragmentWrapper<PipelineViewFragmentType> = {
  fragment: PIPELINE_VIEW_FRAGMENT,
  fragmentName: 'PipelineViewFragment',
};
